import styled from 'styled-components';
import {devicesMax} from "../..//utils/responsive"

export const Container = styled.div`
@media ${devicesMax.tablet}{
  &.div-table{
    overflow-x:auto;
  }
}

}
`;

export const Filters = styled.div`
  display: flex;
  /* Rotulo longo ("Vale Capul Disponivel") quebra em 2 linhas: alinhar pela
     base mantem todos os campos na mesma linha */
  align-items: flex-end;

 &.comCelular{
  display: none;
 }

  @media ${devicesMax.tablet} { 

    &.comCelular {
      display:block;
     }

     &.semCelular {
      display:none;
     }
  }

 
`

export const InputGroup = styled.div`
  margin: 15px;

  @media ${devicesMax.mobileL} {
    display:block;
  }


`;